<template>
  <button class="button" v-bind:class="[variant, color, size]" @click="onClick">
    <slot></slot>
  </button>
</template>

<script>
export default {
  name: "Btn",
  props: {
    onClick: {
      type: Function,
      default: () => null
    },
    variant: {
      type: String,
      default: "text"
    },
    color: {
      type: String,
      default: "default"
    },
    size: {
      type: String,
      default: "md"
    }
  }
};
</script>

<style scoped>
.button {
  width: auto;
  font-size: 12px;
  line-height: 1;
  transition: 0.3s ease-in;
  cursor: pointer;
  outline: none;
  padding: 8px 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.button.sm {
  font-size: 10px;
}

.button.lg {
  font-size: 14px;
  padding: 16px;
}

.text {
  background: transparent;
  border: none;
  color: #fff;
}

.text:disabled {
  opacity: 0.5;
}

.contained {
  background: rgba(255, 255, 255, 0.15);
  border: none;
  border-radius: 100px;
  color: #fff;
  font-weight: bold;
}

.contained:hover {
  background: rgba(255, 255, 255, 0.25);
}

.contained.primary {
  background: #2196f3;
}

.contained.primary:hover {
  background: #0f71f3;
}
</style>
